import { tokens } from '@/design';

export type LayerHealthState = 'ready' | 'loading' | 'failed' | 'unsupported' | 'deferred';

export function LayerHealthDot({
  health,
  detail,
}: {
  readonly health: LayerHealthState;
  readonly detail?: string;
}) {
  const defaultLabel =
    health === 'ready'
      ? 'Layer ready'
      : health === 'deferred'
        ? 'Deferred — zoom in to load'
        : health === 'loading'
          ? 'Layer loading'
          : health === 'failed'
            ? 'Layer failed'
            : 'Layer unsupported';
  const label =
    detail && (health === 'unsupported' || health === 'failed') ? detail : defaultLabel;

  const colour =
    health === 'ready'
      ? tokens.color.semantic.success
      : health === 'deferred'
        ? tokens.color.semantic.info
        : health === 'loading'
          ? tokens.color.semantic.warning
          : health === 'failed'
            ? tokens.color.semantic.danger
            : tokens.color.ink.muted;

  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      data-testid={`layer-health-${health}`}
      style={{
        display: 'inline-block',
        width: 8,
        height: 8,
        borderRadius: '50%',
        background: colour,
        flexShrink: 0,
        animation:
          health === 'loading'
            ? 'geoviewer-health-pulse 1.2s ease-in-out infinite'
            : undefined,
      }}
    />
  );
}
